export default function WhyMessagingWins() {
  const channels = [
    { icon: 'ri-phone-line', label: 'Звонок', desc: 'Клиент редко берёт трубку с первого раза. Холодные звонки вызывают раздражение.' },
    { icon: 'ri-message-3-line', label: 'Переписка', desc: 'Клиент отвечает, когда удобно. Видит историю. Может подумать перед ответом.' },
    { icon: 'ri-shield-check-line', label: 'Доверие', desc: 'Последовательная, грамотная коммуникация выстраивает доверие шаг за шагом.' },
    { icon: 'ri-hand-heart-line', label: 'Встреча', desc: 'После переписки клиент уже лоялен и готов к предметному разговору.' },
    { icon: 'ri-check-double-line', label: 'Сделка', desc: 'Грамотно выстроенная переписка подводит клиента к решению естественно.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-line-chart-line"></i>
            Современные реалии продаж
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему сегодня выигрывают те, кто умеет продавать в переписке
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Клиенты всё чаще избегают звонков. Они хотят сначала написать, сравнить предложения, получить документы и задать вопросы в удобном темпе. Если менеджер не умеет вести переписку — клиент уходит.
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-col items-center gap-4">
            {channels.map((item, i) => (
              <div key={i} className="w-full flex items-center gap-4">
                <div className="w-full max-w-xs bg-teal-600 text-white rounded-2xl p-4 md:p-5 flex items-center gap-4 shadow-lg">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-xl text-white`}></i>
                  </div>
                  <div>
                    <div className="font-bold text-base">{item.label}</div>
                    <div className="text-white/75 text-xs leading-relaxed mt-0.5">{item.desc}</div>
                  </div>
                </div>
                {i < channels.length - 1 && (
                  <div className="hidden md:flex flex-col items-center flex-shrink-0 mx-2">
                    <i className="ri-arrow-down-line text-teal-400 text-2xl"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-3xl mx-auto bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-10 text-center">
          <p className="text-lg md:text-xl text-white leading-relaxed font-medium">
            Переписка — это не просто альтернатива звонку. Это самостоятельный канал продаж со своей психологией, скоростью и правилами. Если ваши менеджеры копируют телефонные скрипты в чат — они теряют клиентов.
          </p>
        </div>
      </div>
    </section>
  );
}